import React from 'react';
import { parseToBoolean, isCVMobileApp, getCVFrameUrl } from '../../utils/general/general';
import { cv_setTeamDirLink } from '../../cvMobile/cvAuthor';
import { checkDomEntitlement } from '../../utils/general/checkDomEntitlement';
import { RSCH_HTML_TRACKING_CONFIG } from '../../readership/trackingConfig';
import { enterKeyPressed } from '../../utils/general/enterKey';
import RenditionUrlGenerator from "../../utils/api/renditionUrlGenerator";
import commonStore from '../../store/commonStore';

interface IAuthorsDirectoryProps {
    new_team_directory_url: string;
    teamDirectoryFlag?: string;
    author_directory?: string;
    showOldBranding: boolean;
}
class AuthorsDirectory extends React.PureComponent<IAuthorsDirectoryProps, any> {
    private TEAM_DIRECTORY = React.createRef<HTMLDivElement>();
    constructor(props: IAuthorsDirectoryProps) {
        super(props);
    }

    public componentDidMount() {
        this.TEAM_DIRECTORY.current && checkDomEntitlement(this.TEAM_DIRECTORY.current);
    }

    public openTeamDir = () => {
        RSCH_HTML_TRACKING_CONFIG.trackTeamDirClick();
        return true;
    };

    public authorsDirectoryDom(teamDirectoryUrl?: string) {
        const isCvFrameMapping  = window.HTML_RENDITION.initialData.cvFrameWrapping === "true";
        const menuCode = commonStore.getState().commonStateReducer.menuCode;
        const environment = window.HTML_RENDITION.initialData.environment;
        let directoryUrl = RenditionUrlGenerator.URL_GENERATOR.environments(environment) + teamDirectoryUrl;
        directoryUrl = getCVFrameUrl(menuCode, directoryUrl, 'author_dir');
        const showTeamDir = () => {
            return parseToBoolean(this.props.teamDirectoryFlag || '');
        };
        if (
            (window.HTML_RENDITION.initialData.showDiv('TEAM_DIRECTORY') || showTeamDir()) &&
            !window.HTML_RENDITION.initialData.isPublic
        ) {
            return (
                <div ref={this.TEAM_DIRECTORY} data-entitlement="TEAM_DIRECTORY" className="team-dir author-directory">
                    {this.props.showOldBranding && <h5 className="light-gray">
                        <span className='icon-svg-parent'>
                            <span className="icon-svg icon-author-directory-svg" role="img" aria-label={this.props.author_directory}/>
                        </span>
                        <a
                            tabIndex={0}
                            href={directoryUrl}
                            role="link"
                            target='_blank'
                            onKeyPress={(e) => enterKeyPressed(e, this.openTeamDir.bind(this))}
                            onClick={() => this.openTeamDir()} aria-label={this.props.author_directory}
                        >{this.props.author_directory}
                        </a>
                    </h5>
                    }
                    {!this.props.showOldBranding && <>
                    <span className='icon-svg-parent'>
                            <span className="icon-svg icon-author-directory-svg" role="img" aria-label={this.props.author_directory}/>
                        </span>
                        <a
                            tabIndex={0}
                            href={directoryUrl}
                            role="link"
                            target='_blank'
                            onKeyPress={(e) => enterKeyPressed(e, this.openTeamDir.bind(this))}
                            onClick={() => this.openTeamDir()} aria-label={this.props.author_directory}
                        >{this.props.author_directory}
                        </a>
                        </>}
                </div>
            );
        }
        return <></>;
    }

    public render() {
        let teamDirectoryUrl = this.props.new_team_directory_url;
        if (isCVMobileApp()) {
            teamDirectoryUrl = cv_setTeamDirLink(teamDirectoryUrl);
        }
        return this.authorsDirectoryDom(teamDirectoryUrl);
    }
}
export default AuthorsDirectory;
